import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ThirdParty, ThirdPartyAddress } from 'src/app/core/interfaces/thirdParty';
import { Permission } from 'src/app/core/resources/permission';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ThirdPartyConsignmentService } from '../../cargo/manual-creation-cargo/components/third-party-consignment/third-party-consignment.service';
import { Global } from 'src/app/core/resources/global';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { FormThirdPartyConsignmentComponent } from '../../cargo/manual-creation-cargo/components/form-third-party-consignment/form-third-party-consignment.component';
import { CatalogService } from 'src/app/core/services/catalog.service';
import { BasicCity } from 'src/app/core/interfaces/basicCity';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Utils } from 'src/app/core/resources/utils';
@Component({
  selector: 'app-third-party-detail',
  templateUrl: './third-party-detail.component.html',
  styleUrls: ['./third-party-detail.component.scss']
})
export class ThirdPartyDetailComponent implements OnInit {

  permission = Permission;
  thirdParty: ThirdParty;
  thirdPartyAddressFilter: string = '';
  listThirdPartyAddresses: ThirdPartyAddress[] = [];
  addressId: string = '';
  fromRndcBranchFilter = false;
  rndcBranchAddressId = '';
  municipalityCodeFilter = '';
  thirdPartyDocumentId: string = '';

  constructor(
    private thirdPartyConsignmentService: ThirdPartyConsignmentService,
    public dialog: MatDialog,
    private global: Global,
    public dialogRef: MatDialogRef<ThirdPartyDetailComponent>,
    private catalogService: CatalogService,
    private activatedRoute: ActivatedRoute,
    private permissionRole: PermissionRole,
    private utils: Utils,
    @Inject(MAT_DIALOG_DATA) public dataDialog: {
      thirdParty: ThirdParty
    }
  ) {
    if (this.dataDialog && this.dataDialog.thirdParty) {
      this.thirdParty = this.dataDialog.thirdParty;
    } else {
      const queryParams = this.activatedRoute.snapshot.queryParamMap;
      this.fromRndcBranchFilter = queryParams.get('fromRndcBranch') === 'true'
        || (history.state && history.state.fromRndcBranch === true);
      if (this.fromRndcBranchFilter) {
        this.rndcBranchAddressId = queryParams.get('addressId')
          || (history.state && history.state.addressId ? `${history.state.addressId}` : '');
        this.municipalityCodeFilter = queryParams.get('municipalityCode')
          || (history.state && history.state.municipalityCode ? `${history.state.municipalityCode}` : '');
      }
      this.addressId = !this.fromRndcBranchFilter && history.state && history.state.addressId
        ? `${history.state.addressId}`
        : '';
      const thirdPartySelected = history.state && history.state.thirdPartySelected;
      if (thirdPartySelected) this.thirdParty = thirdPartySelected;
      this.thirdPartyDocumentId = this.activatedRoute.snapshot.paramMap.get('id');
    }
  }


  async ngOnInit() {
    if (!this.thirdParty && this.thirdPartyDocumentId) await this.getThirdParties();
    this.getThirdPartyAddresses();
  }

  private async getThirdParties() {
    try {
      const thirdParties: Array<ThirdParty> = await this.thirdPartyConsignmentService.getThirdPartiesByParent().toPromise();
      if (thirdParties && thirdParties.length > 0) {
        const foundThirdParty = thirdParties.find(tp => tp.document === this.thirdPartyDocumentId);
        if (foundThirdParty) {
          this.thirdParty = foundThirdParty;
          this.getThirdPartyAddresses();
        } else {
          console.error("ThirdParty not found with document:", this.thirdPartyDocumentId);
        }
      }
    } catch (error) {
      console.error("Error fetching third parties:", error);
    }
  }

  public getThirdPartyAddresses() {
    if (!this.thirdParty || !this.thirdParty.document) {
      return;
    }

    const cityFilter = this.fromRndcBranchFilter && this.municipalityCodeFilter
      ? this.municipalityCodeFilter
      : undefined;

    this.thirdPartyConsignmentService.getThirdPartiesAddressByCompany(
      this.thirdParty.document,
      undefined,
      undefined,
      cityFilter
    ).subscribe(
      (success: ThirdPartyAddress[]) => {
        this.listThirdPartyAddresses = success && success.length > 0 ? success : [];
        this.getMunicipalityCodes();
      },
      (error) => this.listThirdPartyAddresses = []
    );
  }

  private async getMunicipalityCodes() {
    for (const address of this.listThirdPartyAddresses) {
      if (address && address.municipalityCode && !this.municipalityCodes[address.municipalityCode]) {
        let cities: BasicCity[] = [];
        try { cities = await this.catalogService.getBasicCityByMunicipalityCode(address.municipalityCode, 1, 5).toPromise(); } catch (error) { continue; }
        this.municipalityCodes[address.municipalityCode] = cities && cities.length > 0 ? cities[0].name : '';
      }
    }
  }

  get municipalityCodes(): { [key: string]: string } {
    return ThirdPartyConsignmentService.thirdPartyMunicipalityCodes;
  }

  createThirdPartyAddress(): void {
    const dialogConfig = new MatDialogConfig();
    const document = this.global.documenTypes.find(doc => doc.id === this.thirdParty.documentType);
    dialogConfig.data = {
      newThirdParty: true,
      title: 'Sede/Dirección de tercero',
      options: {
        thirdParty: { ...this.thirdParty, documentTypeName: document.name, documentTypeId: this.thirdParty.documentType }
      }
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(FormThirdPartyConsignmentComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => result && result.state && this.getThirdPartyAddresses());
  }

  getDocumentType(): string {
    if (!this.thirdParty || !this.thirdParty.documentType) return '-';
    const documentType = this.global.documenTypes.find(type => type.id === this.thirdParty.documentType);
    return documentType ? documentType.name : '-';
  }

  get hasPermissionToViewDeletedAddresses(): boolean {
    return this.permissionRole.hasPermission(this.permission.administration.module, this.permission.administration.viewDeletedThirdpartyAddresses)
  }

  get filteredThirdPartyAddresses(): ThirdPartyAddress[] {
    if (!this.listThirdPartyAddresses || !this.listThirdPartyAddresses.length) return [];

    let addresses = this.listThirdPartyAddresses;
    if (this.fromRndcBranchFilter && this.rndcBranchAddressId) {
      addresses = addresses.filter(
        (address) => address && `${address.addressId}` === `${this.rndcBranchAddressId}`
      );
    }

    if (this.hasPermissionToViewDeletedAddresses) return addresses;
    return addresses.filter((address) => this.utils.thirdPartyAddressIsActive(address));
  }
}
